import React from "react";
import BlurText from "../../Reactbits/TextAnimations/BlurText/BlurText";

function Hero() {
  return (
    <div
      style={{
        backgroundImage: "url('/media/images/ContactBgp.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "92vh",
        display: "flex",
        alignItems: "center",
        color: "white",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col text-center text-md-start">
            <h1
              className="fw-bold"
              style={{
                fontSize: "10vw",
                lineHeight: "1.2",
              }}
            >
              <BlurText
                text="Contact Us"
                className="display"
                animateBy="chars"
                direction="top"
                delay={70}
              />
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
